module.exports = __webpack_public_path__ + "img/kongtiao.6d9adf2d.png";